import { combineReducers, createStore, applyMiddleware } from "redux";
import { thunk } from 'redux-thunk';
import { productDetailReducer, productListReducer, productDeleteReducer, productUpdateReducer } from "./reducers/productDetailReducer";

// Create the Redux store with the rootReducer and apply the thunk middleware
const reducer = combineReducers({
  productDetails: productDetailReducer,
  productList: productListReducer,
  productDelete: productDeleteReducer,
  productUpdate: productUpdateReducer,
});

const store = createStore(reducer, applyMiddleware(thunk));

export default store;